/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { useQuery } from "@tanstack/react-query";
import { getMaterialReportAggregate } from "./materialsReportsFunctions";

export function useMaterialReportAggregate(startDate: string, endDate: string) {
    return useQuery({
        queryKey: ["MATERIALS", "REPORTS", "AGGREGATE", startDate, endDate],
        queryFn: () => getMaterialReportAggregate(startDate, endDate),
        select: ({ data }) => data,
    });
}
